<div class="policy-tracker-container">
  <div class="policy-tracker">
    <mat-card class="policy-card">
      <mat-card-content>
        <div *ngIf="loading$ | async" class="loading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <p>Loading policy information...</p>
        </div>

        <div *ngIf="error$ | async as error" class="error">
          <mat-icon>error</mat-icon>
          <p>{{ error }}</p>
        </div>

        <ng-container *ngIf="policy$ | async as policy">
          <app-policy-tracker-header
            [policy]="policy"
            [status]="policy.status"
            (statusChange)="onStatusChange($event)">
          </app-policy-tracker-header>

          <mat-divider></mat-divider>

          <app-policy-tracker-timeline
            [policy]="policy"
            [status]="policy.status">
          </app-policy-tracker-timeline>

          <mat-divider></mat-divider>

          <app-policy-tracker-info
            [policy]="policy">
          </app-policy-tracker-info>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>